import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { CARRIER_REQUIRED_SALES_ORDER_STATUS_IDS } from './carrier-required-sales-order-status-ids.js';
/** Whether an edit must keep the ship date and delivery assignee set, where an unknown `deliveryScheduled` means the status-only rule. */
export function isDeliveryPlanLocked({ statusId, deliveryScheduled, }) {
    if (!CARRIER_REQUIRED_SALES_ORDER_STATUS_IDS.has(statusId))
        return false;
    return statusId !== SalesOrderStatus.DELIVERY_SCHEDULING || deliveryScheduled !== false;
}
//# sourceMappingURL=is-delivery-plan-locked.js.map